import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadPackages } from '../actions/packages';
import { useStep } from '../hooks/useStep';
import { FoodSelector } from './FoodSelector.js';

import { HotelSelector } from './single-product/HotelSelector';
import { PackageSelector } from './single-product/PackageSelector';

export function SingleProduct() {
    const dispatch = useDispatch();

    const step = useStep();

    useEffect(() => {
        dispatch(LoadPackages(NOJESRESOR_PRODUCT.id));
    }, [dispatch]);

    return (
        <>
            <div className="single-product__content">
                {step === 1 &&
                    <>
                        <PackageSelector />
                        <FoodSelector />
                    </>
                }

                {step === 2 && <HotelSelector />}
            </div>
        </>
    );
}
